import PaymentUtils from 'payment';

export const clearNumber = (value = '') => {
  return value.replace(/\D+/g, '')
}

export const formatCellphone = (value) => {
  if (!value) {
    return value
  }

  let cleanValue = clearNumber(value);

  if(cleanValue.length <= 10){
    value = `(${cleanValue.slice(0, 2)}) ${cleanValue.slice(2, 6)}-${cleanValue.slice(6, 10)}`
  }
  else{
    value = `(${cleanValue.slice(0, 2)}) ${cleanValue.slice(2, 7)}-${cleanValue.slice(7, 11)}`
  }

  return value.trim();
}

export const formatCreditCardNumber = (value) => {
  if (!value) {
    return value
  }

  const issuer = PaymentUtils.fns.cardType(value)
  const clearValue = clearNumber(value)
  let nextValue

  switch (issuer) {
    case 'amex':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 15)}`
      break
    case 'dinersclub':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10
      )} ${clearValue.slice(10, 14)}`
      break
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        8
      )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`
      break
  }

  return nextValue.trim()
}

export const formatCreditCardExpiry = (value) => {
  if (!value) {
    return value
  }
  const clearValue = clearNumber(value);
  let nextValue;

  nextValue = `${clearValue.slice(0, 2)} / ${clearValue.slice(2, 4)}`;

  return nextValue;
}

export const onlyNumbers = (str) => {
  return str.replace(/\D/g, '');
}
